import { motion } from 'framer-motion';

const HeroSection = () => {
  return (
    <section id="hero" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/214dadf4a72e4852173778e0c0cbfe2a.jpg"
          alt="RBF Express - Frota de Transporte Empresarial"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1a237e]/85 via-[#1a237e]/75 to-[#1a237e]/85"></div>
      </div>

      <div className="container mx-auto px-6 lg:px-20 relative z-10 pt-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="text-white"
          >
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="inline-flex items-center bg-[#ff6f00] px-4 py-2 rounded-full mb-6"
            >
              <span className="text-sm font-semibold">Desde 2007 | +15 anos</span>
            </motion.div>

            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
              className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-6"
            >
              Transporte Empresarial Rápido e Seguro no Vale do Paraíba e Sudeste
            </motion.h1>

            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4 }}
              className="text-lg md:text-xl text-white/90 leading-relaxed mb-10 max-w-2xl"
            >
              Coletas empresariais, transporte de peças, malotes e entregas corporativas com moto, carro e caminhão, sob demanda ou contrato mensal.
            </motion.h2>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5 }}
              className="flex flex-col sm:flex-row gap-4"
            >
              <a
                href="https://wa.me/5512991064271?text=Ol%C3%A1!%20Gostaria%20de%20um%20or%C3%A7amento%20para%20transporte%20de%20pe%C3%A7as%2Finsumos%2Fdocumentos%20para%20minha%20empresa."
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center bg-[#ff6f00] text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-[#e66300] transition-all hover:shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-2xl mr-3"></i>
                Falar com um Consultor
              </a>
              <a
                href="https://wa.me/5512991064271?text=Ol%C3%A1!%20Gostaria%20de%20um%20or%C3%A7amento%20para%20transporte%20de%20pe%C3%A7as%2Finsumos%2Fdocumentos%20para%20minha%20empresa."
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center border-2 border-white text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-white hover:text-[#1a237e] transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-file-list-3-line text-2xl mr-3"></i>
                Solicitar Cotação Imediata
              </a>
            </motion.div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="hidden lg:block"
          >
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=modern%20delivery%20motorcycle%20and%20van%20in%20professional%20corporate%20setting%20with%20driver%20in%20uniform%20representing%20fast%20reliable%20business%20logistics%20services%20clean%20background%20with%20motion%20blur%20effect%20emphasizing%20speed%20and%20efficiency&width=800&height=900&seq=rbf-hero-002&orientation=portrait"
                alt="Serviços de Entrega RBF Express"
                className="rounded-2xl shadow-2xl w-full h-auto"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
